import React, { useState } from 'react';

export default function FAQCoupon({
  discountApp,
  discountWeb,
  airportInitial,
  airportName,
}) {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: `What's the discount for ${airportInitial} parking?`,
      answer: `On Air Parking offers exclusive discounts for ATL parking! Save up to $${discountApp} with our app or $${discountWeb} when booking on our website. Just enter the coupon code at checkout—one per booking.`,
    },
    {
      question: `How do I use the parking coupon for ${airportName}?`,
      answer: `AUsing your parking coupon is simple! Just copy the promo code and enter it at checkout on the On Air Parking website or app. Save up to $${discountApp} with the app or $${discountWeb} on the website—one coupon per booking.`,
    },
    {
      question: `How can I get a promo code for ${airportInitial} parking?`,
      answer: `On Air Parking offers exclusive promo codes for ${airportInitial} parking. Find discounts on our website or app, copy the code, and enter it at checkout to save on your booking.`,
    },
    {
      question: `What are the benefits of using promo codes for offsite parking at ${airportName}?`,
      answer: `Using an On Air Parking coupon for ${airportName} gives you extra savings on top of our already low prices. Enjoy cheaper rates than airport parking, a free shuttle to the terminal, and the choice between valet or self-parking. Save more and park stress-free!`,
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full">
      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <div key={index} className="border-b pb-2">
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center text-left font-semibold text-base md:text-lg"
            >
              <span>{faq.question}</span>
              <span className="text-gray-500">
                {openIndex === index ? '-' : '+'}
              </span>
            </button>
            {openIndex === index && (
              <p className="mt-2 text-gray-700">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
